import { UrlConstants } from "../url.constants";
export class ApiModuleMapConstants {
    static URL = UrlConstants.API_V2 + "ModuleMap";
    static FUNCTION_DELETE_MULTIPLE_MODULE_MAPS = "DeleteMultipleModuleMaps";
    static FUNCTION_DELETE_ALL_MODULE_MAPS = "DeleteAllModuleMaps";
}
